import { OnInit, inject } from "@angular/core";
import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ExtendedGenericSystemWithAttachments } from "src/typings/extended-generic-system";
import {
  GenericSystem,
  InterfaceConfiguration,
  YellowFlag,
} from "../../../../codegen/out/types";
import { HvacService } from "../core/hvac.service";

@Component({
  selector: "app-system-detail",
  templateUrl: "./system-detail.component.html",
  styleUrls: ["./system-detail.component.scss"],
  standalone: false,
})
export class SystemDetailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private hvacService = inject(HvacService);

  system: ExtendedGenericSystemWithAttachments;
  interfaceConfigurations: InterfaceConfiguration[];
  yellowFlags: YellowFlag[];
  combinedSystems: GenericSystem[];

  ngOnInit(): void {
    this.system = this.route.snapshot.data.system;

    this.interfaceConfigurations = [...this.system.interfaceConfigurations];
    this.interfaceConfigurations.sort(
      (a, b) => b.interface.priority - a.interface.priority
    );
    const enabledInterfaces = this.interfaceConfigurations.filter(
      (ic) => ic.enabled
    );
    const disabledInterfaces = this.interfaceConfigurations.filter(
      (ic) => !ic.enabled
    );
    this.interfaceConfigurations = enabledInterfaces.concat(disabledInterfaces);

    this.yellowFlags = this.system.yellowFlags.filter((flag) => flag.enabled);

    if (
      this.system.__typename === "BoilerControl" &&
      (this.system.fitInAvailability === "OPTIONAL" ||
        this.system.fitInAvailability === "MANDATORY")
    ) {
      this.combinedSystems = this.system.combinedSystems;
    }
  }

  hasYellowFlags(): boolean {
    return this.yellowFlags.length !== 0;
  }

  hasSystemComment(): boolean {
    return this.system.comment != null && this.system.comment.length !== 0;
  }

  showYellowFlagDivider(index: number): boolean {
    return index !== this.yellowFlags.length - 1;
  }

  openInHvac(): void {
    const url = this.hvacService.getSystemUrl(this.system.id);
    window.open(url, "_blank");
  }
}
